import React, { useMemo } from "react";
import Dialog from "../../../components/Dialog";
import useCamp from "../../../game-engine/hooks/useCamp";
import { useBarracksUIContext } from "../BarracksContext";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

const ConfirmDialog = () => {
  const { isMoveLoading } = useCamp();
  const { t } = useAppTranslation(["common"]);

  const barracksContext = useBarracksUIContext();
  const barracksUIProps = useMemo(() => {
    return {
      confirmDialog: barracksContext?.confirmDialog,
      setConfirmDialog: barracksContext?.setConfirmDialog,
      upgradeLoading: barracksContext?.upgradeLoading,
    };
  }, [
    barracksContext?.upgradeLoading,
    barracksContext?.confirmDialog,
    barracksContext?.setConfirmDialog,
  ]);

  return (
    <Dialog
      loading={!!isMoveLoading || barracksContext?.upgradeLoading}
      title={barracksUIProps?.confirmDialog?.title}
      closeLabel={t("common:actions.no")}
      submitLabel={t("common:actions.yes")}
      onSubmit={barracksUIProps?.confirmDialog?.submit}
      open={barracksUIProps?.confirmDialog?.open ?? false}
      onClose={() =>
        barracksUIProps?.setConfirmDialog?.((prev) => ({
          ...prev,
          open: false,
        }))
      }
    >
      {barracksUIProps?.confirmDialog?.msg}
    </Dialog>
  );
};

export default ConfirmDialog;
